import { render, staticRenderFns } from "./ChatbotButton.vue?vue&type=template&id=0577cdde&scoped=true&"
import script from "./ChatbotButton.vue?vue&type=script&lang=js&"
export * from "./ChatbotButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotButton.vue?vue&type=style&index=0&id=0577cdde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0577cdde",
  null
  
)

export default component.exports